import { Options } from "vue-class-component";

import config from "@/config/config";
import PageBaseView from "@/pages/PageBaseView";
import { ProductType } from "@/domain/product-type.model";

@Options({
  name: "product-type-view",
  props: {
    id: String,
  },
})
export default class ProductTypeView extends PageBaseView {
  public row: ProductType = {
    description: "",
    enabled: false,
  };

  public mounted(): void {
    this.url = "product-type";
    this.module = config.modules.productType;

    this.$store
      .dispatch("productType/get", this.id)
      .then((res: ProductType) => {
        if (res && res.id) {
          this.row = res;
        } else {
          this.errorMessage = "Registro não encontrado.";
        }
      })
      .catch(() => {
        this.errorMessage = "Registro não encontrado.";
      });
  }
}
